/* global google, contactPageData */

/**
 * Contact Page — Locations + Google Map
 *
 * Initialised as the Maps API callback (window.initContactMap).
 * All location data is passed via wp_localize_script as contactPageData.locations.
 */

window.initContactMap = function () {
  var mapEl = document.getElementById( 'contact-map' );
  if ( ! mapEl ) return;

  var locations = ( contactPageData && contactPageData.locations ) ? contactPageData.locations : [];
  if ( ! locations.length ) return;

  // ── Initialise map ───────────────────────────────────────────────────────

  var map = new google.maps.Map( mapEl, {
    center: { lat: locations[0].lat, lng: locations[0].lng },
    zoom: 10,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER,
    },
  } );

  // ── Markers + info windows ───────────────────────────────────────────────

  var markers     = [];
  var infoWindows = [];

  locations.forEach( function ( loc, index ) {
    var marker = new google.maps.Marker( {
      position: { lat: loc.lat, lng: loc.lng },
      map: map,
      title: loc.name,
      icon: contactPageData.markerIcon ? {
        url: contactPageData.markerIcon,
        scaledSize: new google.maps.Size( 28, 28 ),
        anchor: new google.maps.Point( 14, 14 ),
      } : undefined,
    } );

    var infoWindow = new google.maps.InfoWindow( {
      ariaLabel: loc.name,
      content: '<div class="map-info-window"><strong>' + loc.name + '</strong>' +
               ( loc.address ? '<br><span>' + loc.address + '</span>' : '' ) + '</div>',
    } );

    marker.addListener( 'click', function () {
      activateLocation( index );
    } );

    markers.push( marker );
    infoWindows.push( infoWindow );
  } );

  // ── Activate first location on load (no pan) ─────────────────────────────

  activateLocation( 0, false, false );

  // ── Core: activate a location ────────────────────────────────────────────

  function activateLocation( index, shouldPan, shouldScroll ) {
    shouldPan    = shouldPan    !== false;
    shouldScroll = shouldScroll !== false;

    // Update card states
    document.querySelectorAll( '[data-location-index]' ).forEach( function ( card ) {
      card.classList.toggle( 'is-active', parseInt( card.dataset.locationIndex, 10 ) === index );
    } );

    document.querySelectorAll( '[data-location-map-btn]' ).forEach( function ( btn ) {
      var active = parseInt( btn.dataset.locationMapBtn, 10 ) === index;
      btn.setAttribute( 'aria-pressed', active ? 'true' : 'false' );
    } );

    // Close all info windows then open the target
    infoWindows.forEach( function ( iw ) { iw.close(); } );
    if ( infoWindows[ index ] ) {
      infoWindows[ index ].open( map, markers[ index ] );
    }

    // Pan + zoom map
    if ( shouldPan && markers[ index ] ) {
      map.panTo( markers[ index ].getPosition() );
      map.setZoom( 14 );
    }

    // Scroll map into view
    if ( shouldScroll && mapEl ) {
      mapEl.scrollIntoView( { behavior: 'smooth', block: 'nearest' } );
    }
  }

  // ── Location card: click ────────────────────────────────────────────────

  document.querySelectorAll( '[data-location-map-btn]' ).forEach( function ( btn ) {
    btn.addEventListener( 'click', function () {
      activateLocation( parseInt( btn.dataset.locationMapBtn, 10 ) );
    } );
  } );

  document.querySelectorAll( '.contact-location-card' ).forEach( function ( card ) {
    card.addEventListener( 'click', function ( e ) {
      if ( e.target.closest( 'a, [data-location-map-btn]' ) ) return;
      if ( window.getSelection && window.getSelection().toString() ) return;

      var btn = card.querySelector( '[data-location-map-btn]' );
      if ( btn ) {
        activateLocation( parseInt( btn.dataset.locationMapBtn, 10 ) );
      }
    } );
  } );

  // ── Postal code search ───────────────────────────────────────────────────

  var searchInput = document.querySelector( '[data-location-search]' );
  var searchBtn   = document.querySelector( '[data-location-search-btn]' );

  function runSearch() {
    var query = searchInput ? searchInput.value.trim() : '';
    if ( ! query ) return;

    var geocoder = new google.maps.Geocoder();
    geocoder.geocode( { address: query + ', Canada' }, function ( results, status ) {
      if ( status !== 'OK' || ! results.length ) {
        searchInput && searchInput.setAttribute( 'aria-invalid', 'true' );
        return;
      }
      searchInput && searchInput.setAttribute( 'aria-invalid', 'false' );
      var pos     = results[0].geometry.location;
      var nearest = findNearest( pos.lat(), pos.lng() );
      activateLocation( nearest );
    } );
  }

  if ( searchBtn ) {
    searchBtn.addEventListener( 'click', runSearch );
  }

  if ( searchInput ) {
    searchInput.addEventListener( 'keydown', function ( e ) {
      if ( e.key === 'Enter' ) { e.preventDefault(); runSearch(); }
    } );
  }

  // ── Geolocation: "Search closest location to me" ─────────────────────────

  var geoBtn = document.querySelector( '[data-use-my-location]' );

  if ( geoBtn ) {
    geoBtn.addEventListener( 'click', function () {
      if ( ! navigator.geolocation ) return;

      geoBtn.disabled = true;
      geoBtn.setAttribute( 'aria-busy', 'true' );

      navigator.geolocation.getCurrentPosition(
        function ( position ) {
          var nearest = findNearest( position.coords.latitude, position.coords.longitude );
          activateLocation( nearest );
          geoBtn.disabled = false;
          geoBtn.setAttribute( 'aria-busy', 'false' );
        },
        function () {
          geoBtn.disabled = false;
          geoBtn.setAttribute( 'aria-busy', 'false' );
        }
      );
    } );
  }

  // ── Helpers ──────────────────────────────────────────────────────────────

  function findNearest( lat, lng ) {
    var minDist = Infinity;
    var nearest = 0;
    locations.forEach( function ( loc, i ) {
      var d = haversine( lat, lng, loc.lat, loc.lng );
      if ( d < minDist ) { minDist = d; nearest = i; }
    } );
    return nearest;
  }

  function haversine( lat1, lng1, lat2, lng2 ) {
    var R    = 6371;
    var dLat = ( lat2 - lat1 ) * Math.PI / 180;
    var dLng = ( lng2 - lng1 ) * Math.PI / 180;
    var a    = Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) +
               Math.cos( lat1 * Math.PI / 180 ) * Math.cos( lat2 * Math.PI / 180 ) *
               Math.sin( dLng / 2 ) * Math.sin( dLng / 2 );
    return R * 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) );
  }
};

/**
 * Product dropdown (Chosen) — open on the current selection.
 *
 * Chosen only tags the chosen option with .result-selected; it never highlights
 * or scrolls to it, so opening a long product list drops you at the top of the
 * list with the selection nowhere in sight. Reuse Chosen's own
 * result_do_highlight(): it highlights AND scrolls the option into view, and
 * sets Chosen's internal result_highlight so the arrow keys continue from the
 * selection rather than jumping back to the first item.
 */
( function ( $ ) {
  if ( ! $ ) return;

  $( document ).on( 'chosen:showing_dropdown', '.gform_wrapper select', function () {
    var chosen = $( this ).data( 'chosen' );
    if ( ! chosen || ! chosen.search_results ) return;

    var $results  = chosen.search_results;
    var $selected = $results.find( '.result-selected.active-result' ).first();
    if ( ! $selected.length ) return;

    chosen.result_do_highlight( $selected );

    // result_do_highlight() scrolls the minimum needed, which can leave the
    // option tucked under the pinned "Category › Material" header. Nudge it clear.
    var $header    = $results.find( '.group-result' ).first();
    var headerH    = $header.length ? $header.outerHeight() : 0;
    var resultsEl  = $results[0];
    var visibleTop = $selected[0].offsetTop - resultsEl.scrollTop;

    if ( visibleTop < headerH ) {
      resultsEl.scrollTop -= ( headerH - visibleTop );
    }
  } );

  function labelChosenSearchInputs() {
    $( '.gform_wrapper .chosen-container' ).each( function () {
      var $container = $( this );
      var $input     = $container.find( '.chosen-search-input' ).not( '[aria-label]' );
      if ( ! $input.length ) return;

      var fieldId = $container.attr( 'id' ) || '';
      var $label  = fieldId
        ? $( 'label[for="' + fieldId.replace( /_chosen$/, '' ) + '"]' )
        : $();
      var name = $label.length ? $label.text().replace( /\*$/, '' ).trim() : '';

      $input.attr( 'aria-label', name ? 'Search ' + name + ' options' : 'Search options' );
    } );
  }

  $( document ).on( 'chosen:ready chosen:showing_dropdown', '.gform_wrapper select', labelChosenSearchInputs );
  $( window ).on( 'load', labelChosenSearchInputs );
  $( document ).on( 'gform_post_render', labelChosenSearchInputs );
} )( window.jQuery );

( function () {
  var mapEl = document.getElementById( 'contact-map' );
  if ( ! mapEl || typeof MutationObserver === 'undefined' ) return;

  function titleFrames() {
    mapEl.querySelectorAll( 'iframe:not([title])' ).forEach( function ( frame ) {
      frame.setAttribute( 'title', 'Google Maps' );
    } );
  }

  new MutationObserver( titleFrames ).observe( mapEl, { childList: true, subtree: true } );
  titleFrames();
} )();
